// extracted by mini-css-extract-plugin
export default {"counter_btns":"Counter_counter_btns__fuQgd","count":"Counter_count__sGTbZ","mainDiv":"Counter_mainDiv__en-lB","bgColor":"Counter_bgColor__I5PdQ"};